<template>
  <div class="page-productDetails">
    <Header :callback="getUserInfo" :showBack="true"/>
    <div class="page-content">
      <div class="top-base">
        <div class="info-content">
          <h2 class="top-title" v-html="pageData.FORMULA_NAME"></h2>
          <p class="subtitle">技术数据表由<router-link :to="`/search/result?keyword=&type=1&manufacturer=${pageData.MUNUFACTURER_ID}&manufacturername=${encodeURIComponent(encodeURIComponent(pageData.MUNUFACTURER_ABBREVIATION))}`" class="company">{{pageData.MUNUFACTURER_ABBREVIATION}}</router-link><i class="company-icon" v-if="companyAuth"></i>提供并授权发布</p>
        </div>
        <div class="get-invoice" @click="setDialogInvoiceVisible">
          <p><span class="invoice-text">索取样品</span></p>
        </div>
        <div class="introduce">
          <div class="introduce-item" v-if="pageData.label > 0">
            <span class="label">配方特点</span>
            <span class="text">
              <em v-for="(item, index) in pageData.label" :key="item.LABEL_ID">
                {{item.LABEL_NAME}} {{index < pageData.label.length - 1 ? '/' : ''}}
              </em>
            </span>
          </div>
          <div class="introduce-item" v-if="pageData.ADHIBITION_TYPE != ''">
            <span class="label">应用领域</span>
            <span class="text">{{pageData.ADHIBITION_TYPE}}</span>
          </div>
          <div class="introduce-item block" v-if="pageData.MUNUFACTURER_ABBREVIATION != ''">
            <span class="label">生产商</span>
            <span class="text">{{pageData.MUNUFACTURER_ABBREVIATION}}</span>
          </div>
        </div>
        <div class="preface" v-if="pageData.FORMULA_INTRODUCE != ''" v-html="pageData.FORMULA_INTRODUCE"></div>
      </div>
      <div class="tab-btn">
        <span class="btn-item" :class="{active: tabIndex === 0}" @click="tabAction(0)">配方详情</span>
        <span class="btn-item" :class="{active: tabIndex === 1}" @click="tabAction(1)">专家互动</span>
        <span class="btn-item" :class="{active: tabIndex === 2}" @click="tabAction(2)">相关推荐</span>
      </div>
      <div class="tab-view">
        <div class="tab-box" v-show="tabIndex === 0">
          <div class="tab-panel" v-if="storeData">
            <div class="product-details">
              <div class="top">
                <img :src="storeData.pc_logo || config.DEFAULT_SHOP_LOGO" alt="" class="cover shop_logo" @click="gotoShop(storeData.shop_domain)"/>
                <div class="company-info">
                  <p class="name line-clamp-1" @click="gotoShop(storeData.shop_domain)">{{storeData.common_service}}</p>
                  <ul class="company-info-list">
                    <li>
                      <label>商品丰富</label> <span>{{storeData.quality}}</span>
                    </li>
                    <li>
                      <label>供应链支持</label> <span>{{storeData.services}}</span>
                    </li>
                    <li>
                      <label>技术保障</label> <span>{{storeData.innovation}}</span>
                    </li>
                    <li>
                      <label>供货稳定</label> <span>{{storeData.service}}</span>
                    </li>
                    <li>
                      <label>快速响应</label> <span>{{storeData.performance}}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="video-box" v-if="supplierData.material_supplier">
                <span class="video-label">供应商</span>
                <div class="video-group">
                  <img :src="item.logo" alt="" class="video-img" v-for="item in supplierData.material_supplier" :key="item.name" @click="gotoOuterChain(item.url)"/>
                </div>
              </div>
              <div class="video-box" v-if="supplierData.preferred_customers">
                <span class="video-label">客户</span>
                <div class="video-group">
                  <img :src="item.logo" alt="" class="video-img" v-for="item in supplierData.preferred_customers" :key="item.name" @click="gotoOuterChain(item.url)"/>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-panel" v-if="pageData.fORMULACOMPONENTs && pageData.fORMULACOMPONENTs.length > 0">
            <h3 class="panel-title">配方参数 Formulation Parameter</h3>
            <div class="formula-table">
              <div class="thead">
                <div class="tr">
                  <span class="th">组分</span>
                  <span class="th">成分</span>
                  <span class="th">质量分数%</span>
                </div>
              </div>
              <div class="tbody">
                <div class="tr" v-for="item in pageData.fORMULACOMPONENTs" :key="item.COMPONENT_ID">
                  <span class="td">{{item.GROUPING}}</span>
                  <span class="td line-clamp-1" :class="{component: item.DETAILS_ID && item.DETAILS_ID != '0'}" @click="gotoProDetail(item.DETAILS_ID,item.MUNUFACTURER_ID)" v-html="item.INGREDIENT"></span>
                  <span class="td">{{item.RATIO}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-panel" v-if="pageData.FORMULA_PDF">
            <h3 class="panel-title">相关文件 Related Documents</h3>
            <div class="documents">
              <div class="item" @click="pdfDownload(pageData.FORMULA_PDF)">
                <img src="../../assets/images/download.png" alt="" class="documents-img" />
                <div class="documents-info">
                  <p class="name line-clamp-1">由{{pageData.MUNUFACTURER_ABBREVIATION}}提供{{pageData.FORMULA_PDF_FILE}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-panel" v-if="pageData.TECHNOLOGICAL_PROCESS != ''">
            <h3 class="panel-title">工艺流程 Technological Process</h3>
            <div class="formula-explain" id="id-gy" :class="{'line-clamp-3': !technologicalVisible}" v-html="pageData.TECHNOLOGICAL_PROCESS">
            </div>
            <p class="explain-open" v-show="showGYBtn">
              <span class="open-btn" @click="setTechnologicalVisible">{{technologicalVisible ? '收起' : '展开'}}</span>
            </p>
          </div>
          <div class="tab-panel" v-if="pageData.CONSTRUCTION_GUIDANCE != ''">
            <h3 class="panel-title">施工特点 Construction Characteristics</h3>
            <div class="formula-explain" id="id-sg" :class="{'line-clamp-3': !constructionVisible}" v-html="pageData.CONSTRUCTION_GUIDANCE"></div>
            <p class="explain-open" v-show="showSGBtn">
              <span class="open-btn" @click="setConstructionVisible">{{constructionVisible ? '收起' : '展开'}}</span>
            </p>
          </div>
        </div>
        <div class="tab-box" v-show="tabIndex === 1">
          <div class="tab-panel" v-if="expertList.length > 0">
          		<h3 class="panel-title">优选专家 Optimization Expert</h3>
          		<div class="recommend-expert">
          			<div class="expert-item" v-for="item in expertList">
          				<a :href="`${config.MAPI}/expert/${item.id}`"><img :src="item.logoUrl" alt="" class="cover" /></a>
          				<p class="name">{{ item.fullname }}</p>
          				<p class="type" v-if="item.expertLabels && item.expertLabels[0] && item.expertLabels[0].labelName3">{{ item.expertLabels[0].labelName3 }}</p>
          			</div>

          		</div>
          	</div>
          	<div class="tab-panel relative">
          		<div class="suply-btn" @click="doProblem()"></div>
          		<h3 class="panel-title">互动问题 Q&A</h3>
          		<div class="interact">
          			<div class="interact-list">
          				<div class="interact-item" v-for="(item, index) in commentList">
          					<div class="user">
          						<div class="user-info">
          							<img :src="item.user_img" alt="" class="cover" />
          							<div class="base">
          								<p :class="`name ${item.user_type == 1 ? 'expert' : '' }`">{{ item.user_type == 0 ? '用户' : '专家' }}-{{ item.user_name }} {{ item.user_type == 1 ? ('|' + item.expert_good ) : '' }}</p>
          								<p class="time">{{ item.add_time }}</p>
          							</div>
          						</div>

          						<span class="reply-btn" @click="doReply(item)"><i class="icon"></i><a class="reply-text">回复({{ commentLevelTwoList[index] ? commentLevelTwoList[index].model ? commentLevelTwoList[index].model.length : '' : '' }})</a></span>
          					</div>

          					<div class="interact-warrper">
                      <div :data-open="item.isOpen ? 1: 2" :class="`interact-text ${item.isOpen ? '' : 'line-clamp-3'}`" >
                        {{  item.isOpen ? item.interactive_content : (item.interactive_content.slice(0, 63) + '...')  }}
                      </div>
                      <span class="show-btn" @click="openComment(index)" v-show="item.interactive_content ? item.interactive_content.length > 63 ? true : false : false">{{ item.isOpen ? '收起' : '展开' }}</span>
                    </div>
          					<div class="other-reply" v-show="commentLevelTwoList[index] ? commentLevelTwoList[index].model.length ? true : false :false">
          						<div class="interact-item" v-for="(items, dataIndex) in commentLevelTwoList[index] ? commentLevelTwoList[index].model ? commentLevelTwoList[index].model : [] : []">
          							<div class="user">
          								<div class="user-info">
          									<img :src="items.user_img" alt="" class="cover" />
          									<div class="base">
                              <p :class="`name ${items.user_type == 1 ? 'expert' : '' }`">{{ items.user_type == 0 ? '用戶' : '专家' }}-{{items.user_name}} {{ items.user_type == 1 ? ('|' + items.expert_good ) : '' }} </p>
                              <p class="time">{{ items.add_time }}</p>
                            </div>
          								</div>
          							</div>

          							<div class="interact-warrper">
                          <div :data-open="commentLevelTwoList[index].model[dataIndex].isOpen ? 1: 2" :class="`interact-text ${commentLevelTwoList[index].model[dataIndex].isOpen ? '' : 'line-clamp-3'}`" >
                            {{  commentLevelTwoList[index].model[dataIndex].isOpen ? items.interactive_content : (items.interactive_content.slice(0, 63) + '...')  }}
                          </div>
                          <span class="show-btn" @click="openCommentLevelTwo(index, dataIndex)"  v-show="items.interactive_content ? items.interactive_content.length > 63 ? true : false : false">{{ commentLevelTwoList[index].model[dataIndex].isOpen ? '收起' : '展开' }}</span>
                        </div>
          						</div>

          						<p class="get-more"><span class="more-text" @click="downloadCommentLevelTwo(index,commentList[index].interactive_id)" v-show="commentLevelTwoList[index] ? commentLevelTwoList[index].page_count ? commentLevelTwoList[index].page >= commentLevelTwoList[index].page_count ? false : true: false : false">查看更多 <i class="more-icon"></i></span></p>
          					</div>
          				</div>
          			</div>
          			<p class="get-more"><span class="more-text" @click="downloadComment()" v-show="!commentIsLoading && commentList.length > 0">查看更多 <i class="more-icon"></i></span></p>
          		</div>
          	</div>
          </div>
        <div class="tab-box" v-show="tabIndex === 2">
          <ul class="search-formula-item">
            <li v-for="item in formulaList" :key="item.FORMULA_ID">
              <a :href="`/#/formuladetails?formula_id=${item.FORMULA_ID}`">
                <div class="search-formula-itemt">
                  <strong>{{item.FORMULA_NAME}}由{{item.MUNUFACTURER_ABBREVIATION}}提供</strong>
                  <div class="characteristic">
                    <span v-for="label in item.FORMULA_LABEL_ARRAY" :key="label">{{label}}</span>
                  </div>
                  <p>应用领域：{{item.ADHIBITION_TYPE}}</p>
                  <p>提供商：{{item.FORMULA_COMPANY}}</p>
                </div>
                <div class="search-formula-btn">
                  <img src="../../assets/images/icon-yl.png" alt="" v-if="item.IS_RECOMMEND == 1">
                  查看详情
                </div>
              </a>
            </li>
          </ul>
          <p class="tips" v-show="formulaList.length === 0">暂无更多数据</p>
          <div class="text-center">
            <button class="recommed-more-btn" @click="gotoSearchFormula">查看更多</button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <div class="dialog comment" v-show="dialogCommentShow">
    	<div class="dialog-content">
    		<div class="supply-comment">
    			<div class="comment-head">
    				<span class="left" @click="removeReply()">取消</span>
    				<span class="title">{{ replyType === 1 ? '回复互动' : '发布互动' }}</span>
    				<button class="right" @click="submitReply()" >{{ replyType === 1 ? '回复' : '发布' }}</button>
    			</div>
    			<div class="comment-content">
    				<textarea maxlength="1000" :placeholder="`${replyType === 1 ? '回复互动...' : '发布互动...'}`" v-model="suplyText" @input="changeText($event)"></textarea>
    				<p class="max-length"><span>{{ suplyTextLength }}</span>/1000</p>
    			</div>
    		</div>
    	</div>
    </div>
    <Toast :text="toastText" :visible="toastVisible" />
    <mt-popup
      v-model="popupVisible2"
      popup-transition="popup-fade"
      position="bottom">
  
        <City :success="success"  :remove = "remove"   />
    </mt-popup>
    <!-- <demand-btn :instance="$demoInstance" :save-options="{data_source: 2, u_source: 2}"/> -->
  </div>
</template>

<script>
  import header from '../common/header';
  import footer from '../common/footer';
  import config from '../../common/config.js';
  import axios from 'axios';
  import qs from 'qs';
  import toast from '../ui/toast.vue'
  import city from '../ui/city.vue'
  export default {
    name: '',
    data() {
      return {
        id: this.$route.query.formula_id || '', // 配方id
        userInfo: null, // 用户信息
        config,
        pageData: {
          fORMULACOMPONENTs: [], // 重要参数
          label: [] // 配方特点
        }, // 页面数据
        storeData: {}, // 店铺数据
        supplierData: {
          material_supplier: [], // 供应商
          preferred_customers: [] // 客户
        }, // 供应商数据
        formulaList: [], // 推荐配方
        rateOneNum: 2,
        rateTwoNum: 0,
        dialogInvoiceShow: false,
        dialogCommentShow: false,
        technologicalVisible: false, // 工艺可视化
        constructionVisible: false, // 施工可视
        tabIndex: 0, // 切换
        companyAuth: false, // 企业是否授权
        toastText: '', // 提示内容
        toastVisible: false, // 提示框
        toastTimer: null,
        // modelSampleUser: '', // 小样联系人
        // modelSampleTel: '', // 小样手机
        // modelSampleCompany: '', // 小样公司
        // modelSampleJob: '', // 小样职位
        // modelSampleMessage: '', // 留言
        showGYBtn: false, // 是否显示工艺展开收起按钮
        showSGBtn: false, // 是否显示施工展开收起按钮
        expertList: [], // 专家
        commentList: [], // 评论列表
        commentPage: 1,
        commentIsLoading: false,
        commentLevelTwoList: [],
        replyType: 1, // 1回復
        suplyText: '', //  提交文本
        suplyTextLength: 0,
        popupVisible2: false,
        myCity: '',
        province: '',
        city: '',
        district: '',
        detailed_address: '',
        content: '',
        province_str: '',
        city_str: '',
        district_str: ''
      }
    },
    mounted() {
      _hmt.push(['_trackPageview', `/${window.location.hash}`]);
      this.getData();
    },
    methods: {
      toast(text) {
        this.toastText = text;
        this.toastVisible = true;
        if (this.toastTimer) clearTimeout(this.toastTimer);
        this.toastTimer = setTimeout(() => {
          this.toastText = '';
          this.toastVisible = false;
        }, 2000);
      },
      success(val) {
        const str = val[0].region_name +'-' + val[1].region_name + '-' + val[2].region_name;
        this.myCity = str;

        this.province_str = val[0].region_name;
        this.city_str = val[1].region_name;
        this.district_str = val[2].region_name;
        this.province = val[0].id;
        this.city = val[1].id;
        this.district = val[2].id;
        this.popupVisible2 = false;
      },
      remove() {
        this.popupVisible2 = false;
      },
      openCity () {
        this.popupVisible2 = true;
      },
      // 获取页面数据
      getData() {
        axios.get(`${config.PHPHOST}api/web/index.php?r=formula/formula-detail&formula_id=${this.id}`)
          .then(r => {
            r = r.data;
            if (r.flag === 1) {
              this.pageData = r.data.formulaData;
              this.getStoreInfo();
              this.getSupplier();
              this.getFormula();
              this.checkCompanyAuth();
              this.getExpertList();
              this.getCommentList();
              this.$nextTick(() => {
                if (this.pageData.TECHNOLOGICAL_PROCESS != '') {
                  const gyHeight = document.getElementById('id-gy').offsetHeight;
                  if (gyHeight >= 48) this.showGYBtn = true;
                }
                if (this.pageData.CONSTRUCTION_GUIDANCE != '') {
                  const sgHeight = document.getElementById('id-sg').offsetHeight;
                  if (sgHeight >= 48) this.showSGBtn = true;
                }
              });
            }

            var title = this.pageData.FORMULA_NAME + '-优料库-材料创新者智慧数据库',
            desc = `这是${this.pageData.MUNUFACTURER_ABBREVIATION}提供的一种配方，该配方主要应用在${this.pageData.ADHIBITION_TYPE}领域。`;
            title = title.replace(/<sup>|<\/sup>/img, '');
            desc = desc.replace(/<sup>|<\/sup>/img, '');
            document.title = title;


            WeChatShare({
                callback: () => {
                  var imgUrl = config.PHPHOST + 'frontend/web/images/logo-new.jpg',
                  link = window.location.origin + '/#/formuladetails?formula_id=' + this.id;

                    wx.onMenuShareAppMessage({
                        title: title,
                        desc: desc,
                        link: link,
                        imgUrl: imgUrl
                    });
                    wx.onMenuShareTimeline({
                        title: title,
                        desc: desc,
                        link: link,
                        imgUrl: imgUrl
                    });
                  },
              data: 'jsApiDomain=&url=' + encodeURIComponent(window.location.href),
              url: config.MAPI
          });
          });
      },
      /**
       * 成分跳转详情
       * @param {Object} pid 商品id
       */
      gotoProDetail(pid, muid) {
        if (!pid || pid == '0') return;
        this.$router.push({
          path: 'prodetail',
          query: {
            id: pid,
            munufacturer_id: muid
          }
        });
      },
      /**
       * PDF下载
       * @param {Object} url 下载链接
       */
      pdfDownload(url) {
        window.location.href = config.PHPHOST + url;
      },
      // 工艺可视化
      setTechnologicalVisible() {
        this.technologicalVisible = !this.technologicalVisible;
      },
      // 施工可视化
      setConstructionVisible() {
        this.constructionVisible = !this.constructionVisible;
      },
      // 获取店铺信息
      getStoreInfo() {
        axios.post(`${config.MallApi}api/wshop/shop/shop-visiting-card`, qs.stringify({
          companyId: this.pageData.MUNUFACTURER_ID
        })).then(r => {
          r = r.data;
          if (r.error_code === 0) {
            this.storeData = r.data;
          } else {
            this.storeData = null;
          }
        });
      },
      // 获取供应商、客户
      getSupplier() {
        axios.get(`${config.MallApi}api/wshop/shop/supplier-customers?companyId=${this.pageData.MUNUFACTURER_ID}`).then(
          r => {
            r = r.data;
            if (r.error_code === 0) {
              this.supplierData = r.data;
            }
          });
      },
      /**
       * 切换
       * @param {Object} index 索引
       */
      tabAction(index) {
        this.tabIndex = index;
      },
      // 获取推荐配方
      getFormula() {
        axios.post(`${config.PHPHOST}api/web/index.php?r=formula/formula-data`, qs.stringify({
            munu_id: this.pageData.MUNUFACTURER_ID,
            formula_id: this.id
          }))
          .then(r => {
            r = r.data;
            if (r.error_code === 0) {
              this.formulaList = r.data;
            }
          });
      },
      // 跳转到配方搜索
      gotoSearchFormula() {
        this.$router.push({
          path: '/search/result',
          query: {
            type: 1,
            manufacturer: this.pageData.MUNUFACTURER_ID
          }
        });
      },
      // 检测企业是否认证
      checkCompanyAuth() {
        axios.get(`${config.API}out/api/company/attestation/check?companyId=${this.pageData.MUNUFACTURER_ID}`)
        .then(r => {
          r = r.data;
          if (r.code === 1) {
            this.companyAuth = r.obj;
          }
        });
      },
      /**
       * 索取样品可视化
       */
      setDialogInvoiceVisible() {
        this.$demoInstance.show({
          goods_name: this.pageData.FORMULA_NAME,
          goods_id: this.id,
          company_id: this.pageData.MUNUFACTURER_ID,
          data_source: 2,
          u_source: 2
        }, {
          productName: this.pageData.FORMULA_NAME,
          model: '',
          manufacturer: this.pageData.FORMULA_COMPANY
        });
      },
      /**
       * 用户信息
       * @param {Object} data 用户信息
       */
      getUserInfo(data) {
        this.userInfo = data;
      },
      // 专家
      getExpertList() {
      	axios.post(config.API + 'out/api/expert/companyExpert', qs.stringify({
               	companyId: this.pageData.MUNUFACTURER_ID,
               	num: 3,
              })).then(res => {
      		if(res.data.code === 1){
      			this.expertList = res.data.obj;
      		}
              })
      },
      // 加载评论
      downloadComment() {
      	this.commentPage = this.commentPage +1;
      	this.getCommentList();
      },
      // 获取评论
      getCommentList() {
      	if(!this.commentIsLoading) {
      		this.commentIsLoading = true;
      	}
      	axios.post(config.PHPHOST + 'api/web/index.php?r=second/interactive/interactive-list', qs.stringify({
               	Id: this.id,
               	typeId: 2,
               	page: this.commentPage,
               	pageSize: 10,
              })).then(res => {
      		if(res.data.error_code === 0) {
      			var totalNum = Number(res.data.data.total_num);
      			var isEnd = this.commentPage >= Math.ceil(totalNum/10) ? true : false;
      			if(!isEnd ) {
      				this.commentIsLoading = false;
      			}
      			if(res.data.data.model) {
              this.commentList = this.commentList.concat(res.data.data.model);
      				this.promiseComment([...res.data.data.model]);
      			}
      		}
              })
      },
      // 加载留言
      downloadCommentLevelTwo(index, id) {
      	axios.post(config.PHPHOST + 'api/web/index.php?r=second/interactive/interactive-id', qs.stringify({
               	interactiveId: id,
               	pageSize: 2,
               	page: Number(this.commentLevelTwoList[index].page) + 1,
              })).then(data => {

              	if(!data.data.data.model) {
              		return ;
              	}

              	this.commentLevelTwoList[index].model = this.commentLevelTwoList[index].model.concat(data.data.data.model);
              	this.commentLevelTwoList[index].page = Number(data.data.data.page);
              })
      },
      // 获取留言
      promiseComment(arr) {
      	const that = this;
      	((arr) => {
      		let  fn = new Promise((res, rej) => {
      			axios.post(config.PHPHOST + 'api/web/index.php?r=second/interactive/interactive-id', qs.stringify({
                   	interactiveId: arr[0].interactive_id,
                   	pageSize: 2,
                   	page: arr[0].page ? arr[0].page : 1,
                  })).then(data => {
      				res(data)
                  })
      		})

      		fn.then(newRes => {
      			that.commentLevelTwoList = that.commentLevelTwoList.concat([newRes.data.data.model ? newRes.data.data : { model: [] }])
      			arr.shift();
      			if(arr.length > 0) {
      				that.promiseComment(arr)
      			}
      		})

      	})(arr)

      },
      openComment(index) {
      	var newData = [...this.commentList];

      	if(newData[index].isOpen) {
      		newData[index].isOpen = false;
      	}else {
      		newData[index].isOpen = true;
      	}

      	this.commentList = newData;
      },
      openCommentLevelTwo(index, dataIndex) {
        var newData = [...this.commentLevelTwoList];



        if(newData[index].model[dataIndex].isOpen) {
          newData[index].model[dataIndex].isOpen = false;
        }else {
          newData[index].model[dataIndex].isOpen = true;
        }
        this.commentLevelTwoList = newData;
      },
      // 回復
      doReply(data) {
       if (!this.userInfo) {
         return window.location.href = config.USERAPI + 'mobile/uc/build/login?returnUrl=' + encodeURIComponent(encodeURIComponent(window.location.href));
       }
      	this.replyType = 1;
      	this.dialogCommentShow = true;
      	this.productId = data.product_id;
      	this.pid = data.interactive_id;
      },
      // 发布问题
      doProblem() {
        if (!this.userInfo) {
          return window.location.href = config.USERAPI + 'mobile/uc/build/login?returnUrl=' + encodeURIComponent(encodeURIComponent(window.location.href));
        }
      	this.replyType = 0;
      	this.dialogCommentShow = true;
      },
      // 字数统计
      changeText(e) {
      	var val = e.target.value;
      	this.suplyTextLength = val.length;
      },
      // 取消
      removeReply() {
      	this.suplyText = '';
        this.suplyTextLength = 0;
      	this.dialogCommentShow = false;
      },
      submitReply() {
      	axios.post(config.PHPHOST + 'api/web/index.php?r=second/interactive/save-interactive', qs.stringify({
          PRODUCT_ID: this.id,
          PRODUCT_NAME: this.pageData.FORMULA_NAME,
          INTERACTIVE_CONTENT: this.suplyText,
          INTERACTIVE_TYPE: this.replyType === 1 ? 1 : 0,
          PID: this.replyType === 1 ? this.pid : 0,
          INFO_TYPE: 2,
        })).then(res => {
          if(res.data.error_code === 0) {
            this.suplyText = '';
            this.suplyTextLength = 0;
            this.dialogCommentShow = false;
            this.toast('信息提交成功，工作人员审核通过后即可浏览您的互动信息');
          }
        });
      },
      /**
       * 跳转外链
       * @param {string} url 链接
       */
      gotoOuterChain(url) {
        if (url) window.location.href = url;
      },
      /**
       * 跳转到店铺
       * @param {Object} url 店铺链接
       */
      gotoShop(url) {
        window.location.href = url;
      }
    },
    components: {
      Header: header,
      Footer: footer,
      Toast: toast,
      City: city
    },
  }
</script>


<style scoped lang="less">
  .page-productDetails {
    background: #0a1a5d;
    font-size: 1.2rem;
    color: #333;
    display: flex;
    flex-direction: column;
    height: 100%;

    button,
    textarea,
    input {
      outline: none;
      box-sizing: border-box;
    }

    .dialog {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .5);
      z-index: 1000;

      &.dialog-big {
        .dialog-content {
          width: 80%;
          .my-score {
            width: 100%;
            height: 40rem;
            overflow-y: auto;
          }
          .score-submit {
            height: 3.2rem;
          }
        }
        .invoice-form {
          .form-input-warrper {
            margin-top: 1rem;
            .label {
              padding-bottom: 1rem;
            }
            .input {
              height: 3.2rem;
            }
            .select-input {
              position: relative;
              width: 100%;
              height: 3.2rem;
              padding: 0 0.5rem;
              border: 1px solid #eee;
              border-radius: 0.25rem;
              background: #fff;
              text-align: left;
              &:after {
                content: '';
                position: absolute;
                top: 1.3rem;
                right: 0.5rem;
                width: 0;
                height: 0;
                border-top: 0.45rem solid #000;
                border-left: 0.45rem solid transparent;
                border-right: 0.45rem solid transparent;
              }
            }
          }
        }
      }

      &.comment {
        background: #fff;

        .dialog-content {
          top: 0;
          left: 0;
          transform: none;
          display: block;
        }

        .supply-comment {
          .comment-head {
            display: flex;
            height: 4.83rem;
            padding: 0 1.45rem 0 1.75rem;
            background: #eaedf7;
            justify-content: space-between;
            align-items: center;
            line-height: 4.83rem;

            .left {
              font-size: 1.2rem;
              color: #474644;
            }

            .title {
              font-size: 1.5rem;
            }

            .right {
              width: 4.5rem;
              height: 2.08rem;
              border: 0.04rem solid #fff;
              background: #597eff;
              border-radius: 1.66rem;
              font-size: 1.2rem;
              font-weight: 900;
              color: #fff;
            }
          }

          .comment-content {
            textarea {
              width: 100%;
              height: 19rem;
              border: 0;
              padding: 1.75rem;
              box-sizing: border-box;
              font-size: 1.3rem;
              line-height: 1.6rem;

              &::placeholder {
                color: #999;
              }
            }

            .max-length {
              padding: 0.5rem 0 0 1.75rem;
              color: #999;
            }
          }
        }
      }

      .dialog-content {
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: inline-block;
      }

      .dialog-close {
        position: absolute;
        right: -1.2rem;
        top: -1.2rem;
        width: 3.33rem;
        height: 3.33rem;
        display: inline-block;
        background: url('../../assets/images/close.png') no-repeat scroll top/cover;
      }

      .my-score {
        width: 21rem;
        background: #fff;
        border-radius: 0.58rem;
        overflow: hidden;

        .my-score-title {
          line-height: 3.75rem;
          text-align: center;
          background: #eaedf7;
          color: #0c2870;
          font-size: 1.4rem;
        }

        .score-group {
          padding: 3.25rem 2.08rem 2.58rem;
          overflow: hidden;

          .score-item {
            padding: 0 1rem;
            margin-bottom: 2.58rem;

            .score-title {
              color: #49557f;
            }

            .score-box {
              display: flex;
              margin-top: 0.83rem;
              justify-content: space-between;

              .scores {}

              .score-img {
                width: 1.54rem;
                height: 1.54rem;
                margin-right: 0.83rem;
              }

              .num {
                font-size: 1.6rem;
                font-weight: 900;
                line-height: 1.54rem;
                color: #001eed;

              }
            }
          }
        }

        .score-submit {
          width: 100%;
          height: 2.8rem;
          background: #597eff;
          color: #fff;
          border: 0;
          font-size: 1.4rem;
          border-radius: 2.33rem;
        }
      }

      .invoice-form {
        padding: 1.75rem 2.08rem 1.8rem;

        .form-input-warrper {
          margin-bottom: 0.6rem;

          .label {
            padding-bottom: 0.45rem;
            color: #666;
          }

          .input {
            width: 100%;
            height: 2.5rem;
            padding: 0 0.5rem;
            border: 1px solid #eee;
            border-radius: 0.25rem;

            &:focus {
              border: 1px solid #a6bbff;
            }
          }

          .textarea {
            width: 100%;
            height: 6.1rem;
            border: 1px solid #eee;
            border-radius: 0.25rem;
            padding: 0.5rem;
            resize: none;

            &:focus {
              border: 1px solid #a6bbff;
            }
          }
        }
      }
    }

    .page-content {
      position: relative;
      background: #f8f8f8;
      border-top-left-radius: 2.92rem;
      border-top-right-radius: 2.92rem;
      padding: 3.25rem 1.25rem 0;
      flex: 1;

      .get-invoice {
        width: 100%;
        height: 2.5rem;
        text-align: center;
        margin-top: 1.5rem;
        .invoice-text {
          width: 94%;
          height: 2.75rem;
          line-height: 2.75rem;
          border-radius: 0.5rem;
          display: inline-block;
          font-size: 1.25rem;
          color: #fff;
          background: #0c317a;
        }
      }
    }

    .line-clamp-3 {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .line-clamp-2 {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .text-center {
      text-align: center;
    }

    .block {
      display: block !important;
    }

    .top-base {
      .introduce {
        padding: 1.5rem 0 0 1rem;

        .introduce-item {
          margin-bottom: 1.5rem;

          .label {
            margin-right: 0.41rem;
            color: #999;
          }
        }
      }

      .preface {
        padding: 2.16rem 0 0 1rem;
        color: #999;
        line-height: 1.7rem;
      }

      .info-content {
        padding: 0 5rem 0 1rem;
      }

      .top-title {
        font-size: 2rem;
        font-weight: 900;
        line-height: 2rem;
      }

      .subtitle {
        padding-top: 1.5rem;
        font-size: 1.2rem;

        .company {
          font-size: 1.2rem;
          font-weight: 900;
          margin: 0 0.84rem 0 0.84rem;
        }

        .company-icon {
          width: 1.5rem;
          height: 1.5rem;
          display: inline-block;
          margin-right: 0.5rem;
          background: url('../../assets/images/company.png') no-repeat scroll center/cover;
          vertical-align: text-bottom;
        }
      }

      .cas {
        padding: 1rem 0 0.84rem;
        font-size: 1.2rem;
      }

      .info {
        margin-bottom: 0.84rem;

        .label {
          margin-right: 0.33rem;
          font-size: 1.2rem;
          color: #999;
        }

        .text {
          margin-right: 1.625rem;
          font-size: 1.2rem;
        }
      }

      .score {
        padding: 2.08rem 0 0 1rem;
        display: flex;

        .score-item {
          position: relative;
          flex: 1 1;
          padding: 0 2% 0 6%;
          font-size: 1.2rem;

          &:first-child {
            padding-left: 0;
          }

          &:after {
            content: '';
            position: absolute;
            bottom: 0;
            right: 0;
            width: 0.084rem;
            height: 1.875rem;
            display: inline-block;
            background: #e6e6e6;
          }

          .score-title {
            color: #999;
          }

          .start {
            float: left;
            padding-top: 0.5rem;
            vertical-align: text-bottom;

            .start-img {
              width: 0.84rem;
              height: 0.84rem;
              margin-right: 0.23rem;
            }
          }

          .num {
            float: left;
            margin-top: 0.5rem;
            margin-left: 0.21rem;
            font-weight: 900;
            color: #666;
          }
        }
      }

      .go-grade {
        width: 27.5%;
        font-size: 1.2rem;
        line-height: 2.5rem;
        text-align: right;

        .grade-icon {
          width: 1.29rem;
          height: 0.71rem;
          display: inline-block;
          margin-left: 0.14rem;
          background: url('../../assets/images/right_blue.png') no-repeat scroll center/cover;
        }
      }
    }

    .tab-btn {
      height: 3.8rem;
      display: flex;
      padding: 0 0.6rem;
      margin: 1.66rem 0;
      border-radius: 2.5rem;
      background: url('../../assets/images/tab_bg.png') no-repeat scroll top/cover;
      background-size: 100% 100%;
      align-items: center;

      .btn-item {
        flex: 1 1;
        height: 3.1rem;
        margin-right: 0.58rem;
        border-radius: 1.8rem;
        text-align: center;
        line-height: 3.1rem;
        color: #525252;

        &.active {
          background: #597eff;
          color: #fff;
          border: 0.05rem solid #fff;
          font-weight: 900;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .tab-view {
      overflow: hidden;
    }

    .tab-panel {
      background: #fff;
      padding: 1rem;
      border-radius: 1rem;
      margin-bottom: 1.83rem;
      box-shadow: 2px 2px 6px #ededed;

      .product-details {
        .top {
          display: flex;
          align-items: center;
          padding: 1.5rem 0 1.5rem 1rem;
          background: #f2f4fb;
          border-radius: 0.5rem;

          .cover {
            width: 7.29rem;
            height: 7.29rem;
            margin-right: 1.25rem;
            min-width: 7.29rem;
          }

          .company-info {
            .name {
              padding: 0.625rem 0 1.08rem;
              font-size: 1.4rem;
              font-weight: bold;
            }

            .text {

              overflow: hidden;
            }

            .product-label {
              float: left;
              width: 5rem;
              color: #999;
              margin: 0 0.25rem 0.75rem 0;
            }

            .product-num {
              float: left;
              margin: 0 0.95rem 0.75rem 0;
              color: #555;
              font-weight: 900;
            }
          }
        }

        .video-box {
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-top: 1.75rem;

          &:last-child {
            margin-bottom: 0.7rem;
          }

          .video-label {
            width: 4.33rem;
            height: 1.91rem;
            display: inline-block;
            font-size: 1.2rem;
            line-height: 1.91rem;
            text-align: center;
            border: 0.05rem solid #bababa;
            border-radius: 1.6rem;
            color: #999;
            margin-right: 2rem;
          }

          .video-group {
            flex: 1;

            .video-img {
              width: 4.25rem;
              height: 4.25rem;
              margin-right: 0.75rem;
              margin-bottom: .5rem;
            }
            a:last-child {
              .video-img {
                margin-right: 0;
              }

            }
          }

          .video-next {
            width: 0.58rem;
            height: 0.95rem;
            display: inline-block;
            margin-right: 0.2rem;
            background: url('../../assets/images/right_black.png') no-repeat scroll center/cover;
          }
        }
      }

      .panel-title {
        padding: 1.2rem 0 .5rem 0.66rem;
        font-size: 1.5rem;
        color: #000b5d;
      }

      .product-info {
        display: flex;
        padding: 0.66rem;
        margin-top: 1.33rem;
        background: #f2f4fb;
        border-radius: 0.33rem;
        text-align: center;

        .info {
          flex: 1 1;
          font-size: 1.2rem;

          .info-title {
            color: #999;
          }

          .info-name {
            font-size: 1.3rem;
            padding-top: 0.66rem;
          }
        }
      }

      .product-type {
        padding: 1.66rem 0 0 0.66rem;

        .type {
          overflow: hidden;
          margin-bottom: 1rem;

          .label {
            float: left;
            margin-right: 0.79rem;
          }

          .type-list {
            float: left;

            li {
              margin-bottom: 0.58rem;
              font-size: 1.3rem;
            }

            .gray {
              margin: 0 0.625rem;
              color: #999;
            }
          }
        }
      }

      .characteristic {
        padding: 0.66rem;
        background: #f2f4fb;
        border-radius: 0.33rem;
        margin-bottom: 1.5rem;
        .characteristic-title {
          color: #999;
        }

        .text {
          padding-top: 0.66rem;
          font-size: 1.3rem;
          line-height: 2.3rem;
        }
      }

      .parameter {
        padding: 0.66rem 0 0.41rem 0.66rem;

        .parameter-item {
          display: inline-block;

          .label {
            margin-right: 0.41rem;
            color: #999;
          }

          .text {
            margin-right: 0.75rem;
          }
        }
      }

      .documents {
        padding: 1.5rem 0 0 0.66rem;

        .item {
          display: flex;
          align-items: center;
          margin-bottom: 1.33rem;

          .documents-img {
            width: 1.58rem;
            height: 1.66rem;
            display: inline-block;
            margin-right: 0.625rem;
            vertical-align: text-bottom;
          }

          .documents-info {
            display: inline-block;
            color: #666;
            flex: 1 1;
            min-width: 20%;

            .name {
              line-height: 1.3rem;
            }
          }
        }
      }

      .base-list {
        padding: 1.06rem 0 0 0.66rem;

        li {
          display: inline-block;
          margin-bottom: 0.5rem;

          .label {
            color: #999;
            margin-right: 0.21rem;
          }

          .text {
            margin-right: 0.5rem;
            font-size: 1.2rem;
          }
        }
      }
    }

    .tab-box {
      .supply-warrper {
        .supply-item {
          display: flex;
          padding: 0.41rem 0.41rem 0.41rem 1.66rem;
          margin-bottom: 1.5rem;

          .supply-left {
            flex: 1 1;

            .supply-info {
              overflow: hidden;
            }

            .supply-label {
              float: left;
              margin: 1rem 0.33rem 0 0;
              color: #999;
            }

            .blue {
              color: #4e75ff;
              font-weight: bold;
            }

            .blod {
              font-weight: bold;
            }

            .supply-text {
              float: left;
              margin: 1rem 1.5rem 0 0;
              font-size: 1.3rem;
            }
          }

          .supply-btn {
            width: 4.375rem;
            height: 4.58rem;
            border: 0;
            background: #f0f2f7;
            font-size: 1.4rem;
            color: #9199b4;
            font-weight: bold;
            border-radius: 0.6rem;
          }
        }
      }

      .recommend-expert {
        display: flex;
        padding-top: 1.58rem;

        .expert-item {
          flex: 1 1;
          text-align: center;

          .cover {
            width: 5.16rem;
            height: 5.16rem;
            border: 0.25rem solid #f2f4fb;
            border-radius: 50%;
            overflow: hidden;
            display: block;
            margin: 0 auto;
          }

          .name {
            padding-top: 0.75rem;
            font-size: 1.6rem;
          }

          .type {
            padding-top: 0.66rem;
            color: #999;
          }
        }
      }

      .interact {
        .interact-list {
          padding: 1.33rem 0;
          border-bottom: 0.08rem solid #efefef;

          .interact-item {
            margin-bottom: 1.5rem;

            &:last-child {
              margin-bottom: 0;
            }

            .user {
              overflow: hidden;
              padding-left: 0.66rem;

              .user-info {
                .cover {
                  float: left;
                  width: 2.66rem;
                  height: 2.66rem;
                  margin-right: 0.66rem;
                }

                .base {
                  float: left;
                }

                .name {
                  padding-top: 0.2rem;
                  font-weight: 600;
                  &.expert {
                    color: #164aff;
                  }
                }

                .time {
                  padding-top: 0.2rem;
                  color: #666;
                }
              }

              .reply-btn {
                float: right;

                .icon {
                  width: 0.83rem;
                  height: 0.71rem;
                  display: inline-block;
                  margin: 1.51rem 0.41rem 0 0;
                  background: url('../../assets/images/message.png') no-repeat scroll top/cover;
                }

                .reply-text {
                  color: #164aff;
                }
              }
            }

            .interact-warrper {
              overflow: hidden;
              padding: 1.04rem 0 0 0.66rem;

              .interact-text {
                color: #666;
                line-height: 1.6rem;
                word-break: break-all;
              }

              .show-btn {
                float: right;
                padding: 0 0.8rem 0 1.6rem;
                line-height: 1.6rem;
                font-weight: bold;
              }
            }

            .other-reply {
              padding: 1.25rem 0;
              margin-top: 1.66rem;
              background: #f6f7fa;
            }
          }
        }

        .get-more {
          padding-top: 1.75rem;
          text-align: center;
          font-size: 1.3rem;
          line-height: 1.3rem;

          .more-icon {
            width: 0.58rem;
            height: 1.16rem;
            display: inline-block;
            margin-left: 0.5rem;
            background: url('../../assets/images/more_icon.png') no-repeat scroll top/cover;
            vertical-align: text-bottom;
          }
        }
      }

      .recommed-list {
        overflow: hidden;

        .recommed-warrper {
          width: 50%;
          float: left;

          .recommend-item {
            padding: 1.33rem 1rem 1.16rem;

            &:nth-of-type(2n) {
              background: #f6f7fa;
            }

            .recommend-title {
              padding: 0 0 0.66rem 0.83rem;
              font-size: 1.7rem;
              font-weight: bold;
              line-height: 2.2rem;
              border-left: 0.16rem solid #5178ff;
            }

            .recommend-text {
              padding: 0 0 0.41rem 0.83rem;
              color: #999;
            }
          }
        }
      }

      .formula-table {
        padding-top: 1.16rem;

        .thead {
          padding: 0;
          background: #f2f4fb;
          border-radius: .5rem;
        }

        .tbody {
          padding: 0 0.83rem;

          .tr {
            border-bottom: 0.08rem dashed #cbcbcb;

            &:last-child {
              border-bottom: 0;
            }
          }
        }

        .tr {
          display: flex;
          text-align: center;
          padding: .5rem 0;

          .th {
            flex: 1 1;
            padding: 0 0.5rem;
            height: 2rem;
            line-height: 2rem;

            &:first-child,
            &:last-child {
              max-width: 30%;
            }

          }

          .td {
            flex: 1 1;
            padding: 0 0.5rem;
            line-height: 3.2rem;

            &:first-child,
            &:last-child {
              max-width: 20%;
            }
          }
        }
      }

      .formula-explain {
        margin: 1rem 0 0.5rem 0.66rem;
        color: #999;
        line-height: 16px;
      }

      .explain-open {
        padding-bottom: 0.41rem;
        text-align: right;
        color: #2d5cff;
        font-weight: 600;
      }
    }

    .recommed-more-btn {
      width: 12.33rem;
      height: 2.5rem;
      margin-bottom: 2.08rem;
      border: 0;
      border-radius: 1.8rem;
      background: #fff;
      color: #344780;
      font-size: 1.3rem;
      box-shadow: 0 6px 18px #dfdfdf;
    }
  }

  .component {
    text-decoration: underline;
  }

  .search-formula-item {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin: 5px;

    li {
      width: 46.5%;
      margin: 0 7% 2rem 0;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 20%;
        width: 60%;
        height: 3px;
        background-color: #597eff;
        border-radius: 3px;
      }

      &:nth-child(2n) {
        margin-right: 0;
      }

      a {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: .5rem;
        box-sizing: border-box;
        background-color: #fff;
        box-shadow: 0 0 5px rgba(0, 0, 0, .2);
        border-radius: 1rem;
      }

      strong {
        display: block;
        height: 4.8rem;
        font-size: 1.8rem;
        line-height: 2.4rem;
        color: #333;
        overflow: hidden;
        margin-top: 3rem;
      }

      .characteristic {
        color: #999;
        font-size: 0;
        height: 5.5rem;
        span {
          display: inline-block;
          vertical-align: top;
          width: 100%;
          font-size: 1.2rem;
          margin-top: .5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:before {
            content: '';
            display: inline-block;
            width: .8rem;
            height: .2rem;
            background-color: #ddd;
            vertical-align: middle;
            margin-right: .5rem;
          }
        }
      }

      p {
        color: #999;
        margin-top: .5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .search-formula-btn {
        position: relative;
        background-color: #f0f2f7;
        color: #a0a7be;
        font-size: 1.3rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-radius: 1rem;
        padding: 1rem;
        margin-top: 1.5rem;
        &.normal {
          justify-content: center;
          img {
            position: static;
            height: .8rem;
            margin-left: .5rem;
          }
        }
        img {
          position: absolute;
          top: .8rem;
          left: .8rem;
          display: block;
          height: 1.6rem;
          margin-left: 0;
        }
      }
    }
  }

  .search-formula-itemt {
    flex: 1;
    padding: 0 .5rem;
  }
  .tips {
    width: 100%;
    text-align: center;
    color: #999;
    font-size: 1.2rem;
    padding: 1rem 0;
  }
  .company-info-list {
    font-size: 0;
    padding-right: 1rem;
    li {
      display: inline-block;
      min-width: 50%;
      font-size: 1.2rem;
      margin-bottom: 1rem;
      label {
        color: #999;
      }
    }
  }
  .tab-view {
  	overflow: hidden;
  	.relative {
  		position: relative;
  	}
  	.suply-btn {
  		position: absolute;
  		top: 1.66rem;
  		right: 0;
  		width: 4.16rem;
  		height: 4.16rem;
  		display: inline-block;
  		background:  url('../../assets/images/suply_btn.png') no-repeat scroll top/cover;
  	}
  }
  .shop_logo {
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/formula_details.vue